export default "__VITE_ASSET__BlOnbWMx__"